import {Component, HostListener, Inject, OnInit} from "@angular/core";
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {NotificationService} from '../../../@services/notification.service';
import {TdDialogService} from '@covalent/core/dialogs';

import {LocalstorageService} from '../../../@services/localstorage.service';
import {take} from 'rxjs';
import {
  DposUser,
  Membership,
  MembershipControllerService,
  Merchant,
  MerchantControllerService
} from "../../../@services/gen";
import {AuthService} from "../../../@services/auth.service";
import {PrinterConfigService} from "../../../@services/printer-config.service";

@Component({
  selector: 'app-printer-config-dialog',
  templateUrl: './printer-config-dialog.component.html',
  styleUrls: ['./printer-config-dialog.component.scss'],
})
export class PrinterConfigDialogComponent implements OnInit{
  merchant: Merchant;
  title = 'Printer Config';
  loading: boolean;
  isMobile: boolean = false;
  isChecked = false;
  user: any;
  posId: string = "";

  constructor(
    private dialogRef: MatDialogRef<PrinterConfigDialogComponent>,
    private printerConfigService: PrinterConfigService,
    private ls: LocalstorageService,
    @Inject(MAT_DIALOG_DATA) private data: any
  ) {
    this.checkIsMobile();
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.checkIsMobile();
  }

  ngOnInit() {
    this.posId = this.ls.getPosId();
/*
     const printerConfig= this.printerConfigService.getPrinterConfig();

     if(printerConfig && printerConfig.isPrintHost){
       this.isChecked = true;
     } else {
       this.isChecked = false;
     }
*/
  }


  private checkIsMobile() {
    this.isMobile = window.innerWidth < 768; // You can adjust the threshold as needed
  }

  submit() {
    this.loading = true;
    this.ls.savePosId(this.posId);

/*
    if(this.isChecked){
      this.printerConfigService.savePrinterConfig(true);
    } else {
      this.printerConfigService.savePrinterConfig(false);
    }
*/

    this.dialogRef.close();
  }


}
